import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioCmp } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_CMP: TIdToPageConfigMap = {
  [PageIdStylioCmp.AGE_CMP]: {
    id: PageIdStylioCmp.AGE_CMP,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioCmp.HAIR_COLOR_CMP]: {
    id: PageIdStylioCmp.HAIR_COLOR_CMP,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.WARDROBE_COLORS_CMP]: {
    id: PageIdStylioCmp.WARDROBE_COLORS_CMP,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.COLOR_CONFIDENCE_CMP]: {
    id: PageIdStylioCmp.COLOR_CONFIDENCE_CMP,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.EYES_COLOR_CMP]: {
    id: PageIdStylioCmp.EYES_COLOR_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.BODY_SHAPE_CMP]: {
    id: PageIdStylioCmp.BODY_SHAPE_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.BODY_SHAPE_CONFIDENCE_CMP]: {
    id: PageIdStylioCmp.BODY_SHAPE_CONFIDENCE_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.SHOW_OFF_FEATURES_CMP]: {
    id: PageIdStylioCmp.SHOW_OFF_FEATURES_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.STYLIO_TO_HELP_CMP]: {
    id: PageIdStylioCmp.STYLIO_TO_HELP_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.MAIN_GOAL_CMP]: {
    id: PageIdStylioCmp.MAIN_GOAL_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.WHERE_TO_SHOP_CMP]: {
    id: PageIdStylioCmp.WHERE_TO_SHOP_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.WARDROBE_PERCENTAGE_CMP]: {
    id: PageIdStylioCmp.WARDROBE_PERCENTAGE_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.URGE_1_CMP]: {
    id: PageIdStylioCmp.URGE_1_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp.URGE_2_CMP]: {
    id: PageIdStylioCmp.URGE_2_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp.URGE_3_CMP]: {
    id: PageIdStylioCmp.URGE_3_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp.URGE_4_CMP]: {
    id: PageIdStylioCmp.URGE_4_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp.URGE_5_CMP]: {
    id: PageIdStylioCmp.URGE_5_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp.URGE_6_CMP]: {
    id: PageIdStylioCmp.URGE_6_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp.FACE_SCAN_INTRO_CMP]: {
    id: PageIdStylioCmp.FACE_SCAN_INTRO_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.FACE_SCAN_ANALYSIS_CMP]: {
    id: PageIdStylioCmp.FACE_SCAN_ANALYSIS_CMP,
  },
  [PageIdStylioCmp.STYLE_PROFILE_CMP]: {
    id: PageIdStylioCmp.STYLE_PROFILE_CMP,
  },
  [PageIdStylioCmp.WARDROBE_READY_CMP]: {
    id: PageIdStylioCmp.WARDROBE_READY_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.URGE_7_CMP]: {
    id: PageIdStylioCmp.URGE_7_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp.URGE_8_CMP]: {
    id: PageIdStylioCmp.URGE_8_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp.STYLE_DRAWN_TO_CMP]: {
    id: PageIdStylioCmp.STYLE_DRAWN_TO_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.OUTFIT_EMOTION_CMP]: {
    id: PageIdStylioCmp.OUTFIT_EMOTION_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.STYLE_DISCOVERY_CMP]: {
    id: PageIdStylioCmp.STYLE_DISCOVERY_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.NOTHING_TO_WEAR_CMP]: {
    id: PageIdStylioCmp.NOTHING_TO_WEAR_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.WARDROBE_FEEL_CMP]: {
    id: PageIdStylioCmp.WARDROBE_FEEL_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.SHOPPING_CMP]: {
    id: PageIdStylioCmp.SHOPPING_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.SHOPPING_BUDGET_CMP]: {
    id: PageIdStylioCmp.SHOPPING_BUDGET_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.SHOPPING_PRIORITY_CMP]: {
    id: PageIdStylioCmp.SHOPPING_PRIORITY_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.CURATED_LINKS_CMP]: {
    id: PageIdStylioCmp.CURATED_LINKS_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.LIFESTYLE_FOCUS_CMP]: {
    id: PageIdStylioCmp.LIFESTYLE_FOCUS_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.OUTFIT_NEEDS_CMP]: {
    id: PageIdStylioCmp.OUTFIT_NEEDS_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.WARDROBE_ALIGNS_CMP]: {
    id: PageIdStylioCmp.WARDROBE_ALIGNS_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.LIFESTYLE_CHANGES_CMP]: {
    id: PageIdStylioCmp.LIFESTYLE_CHANGES_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.AMAZON_FRUSTRATION_CMP]: {
    id: PageIdStylioCmp.AMAZON_FRUSTRATION_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp.PREPARE_FLOW_CMP]: {
    id: PageIdStylioCmp.PREPARE_FLOW_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp.EMAIL_CMP]: {
    id: PageIdStylioCmp.EMAIL_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp.NAME_CMP]: {
    id: PageIdStylioCmp.NAME_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp.READINESS_LEVEL_CMP]: {
    id: PageIdStylioCmp.READINESS_LEVEL_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp.PRE_PAYWALL_OFFER_CMP]: {
    id: PageIdStylioCmp.PRE_PAYWALL_OFFER_CMP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp.SUBSCRIPTIONS_CMP]: {
    id: PageIdStylioCmp.SUBSCRIPTIONS_CMP,
  },
  [PageIdStylioCmp.CANCEL_OFFER_CMP]: {
    id: PageIdStylioCmp.CANCEL_OFFER_CMP,
  },
  [PageIdStylioCmp.AI_STYLIST_UPSELL_CMP]: {
    id: PageIdStylioCmp.AI_STYLIST_UPSELL_CMP,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCmp.SUB_UPSELL_CMP]: {
    id: PageIdStylioCmp.SUB_UPSELL_CMP,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCmp.UPSELL_CMP]: {
    id: PageIdStylioCmp.UPSELL_CMP,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCmp.FACE_UPSELL_CMP]: {
    id: PageIdStylioCmp.FACE_UPSELL_CMP,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCmp.BUNDLE_UPSELL_CMP]: {
    id: PageIdStylioCmp.BUNDLE_UPSELL_CMP,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCmp.DOWNLOAD_CMP]: {
    id: PageIdStylioCmp.DOWNLOAD_CMP,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
